import _ from "lodash";
import AuthProvider from "../../authentication/authService";
import {
  getCSRFToken,
  getOrgStatus,
  setLoading,
  setSignalR,
  setVmIdNotification,
} from "../../../features/store/action";
import { useDispatch } from "react-redux";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import config from "../../authentication/config";
import { customToast } from "../../../App";
import { INotification } from "../../../features/store/model";

export const getPermissionsUtility = (
  permissions: any,
  tenant: any,
  orgsDropDownDataVal: any
) => {
  const currentStatePermissions = permissions.find(
    (res: any) => res.tenantId === tenant
  );
  const data = currentStatePermissions.resourceDetails.filter((res: any) => {
    const isResourceInDropdown = orgsDropDownDataVal.some(
      (val: any) => res.resourceName === val.text
    );
    if (isResourceInDropdown) {
      return {
        resources: res.resources,
        resourceName: res.resourceName,
        permissions: res.permissions,
      };
    }
  });
  return data;
};

export const getOrgDataUtility = (permissions: any, tenant: any) => {
  let orgsDropDownDataVal: any = [];
  _.map(permissions, (val: any) => {
    if (val.tenantId === tenant) {
      orgsDropDownDataVal = val.resourceDetails.map((res: any) => {
        // Do something with res
        return {
          value: res?.resources,
          text:
            res?.resourceName === "" || res?.resourceName === null
              ? res?.resources
              : res?.resourceName,
        };
      });
    }
  });
  return orgsDropDownDataVal;
};

export const handleRefresh = (
  isRefreshed: boolean,
  dispatch: any,
  setToken?: any,
  selectedView?: string
) => {
  if (isRefreshed == true) AuthProvider().clearCookie("XSRF-TOKEN");
  else if (selectedView === "Dashboard") {
    setToken("refreshed");
  }
  AuthProvider()
    .getRefreshToken()
    .then((resp: any) => {
      const tokenData = resp?.access_token;
      selectedView === "Dashboard" && setToken("notRefreshed");
      if (tokenData && resp && isRefreshed == true) {
        dispatch(
          getCSRFToken({
            authorization: localStorage.getItem("access_token"),
          })
        );
      }
    });
};

export const closeConnection = async (
  signalRConnection: any,
  HubConnectionState: any,
  dispatch: any
) => {
  if (
    signalRConnection &&
    signalRConnection.state === HubConnectionState.Connected
  ) {
    await signalRConnection.stop();
    dispatch(setSignalR(null));
    // connection
    // signalRConnection?.onclose((error: any) => {
    //   // console.error(error);
    // });
  }
};

export const setUpSignalRConnection = async (
  orgName: any,
  dispatch: any,
  setSignalrConnection?: any
) => {
  const word = "...";
  let connection: HubConnection;
  connection = new HubConnectionBuilder()
    .withUrl(`${config.API_SERVICE}/notificationhub?siteId=${orgName}`, {
      // accessTokenFactory: () => AuthProvider().getAccessToken(),
    })
    .build();
  setSignalrConnection && setSignalrConnection(connection);
  dispatch(setSignalR(connection));
  connection.on("PushMessage", (user: any, notification: INotification) => {
    if (notification.message) {
      if (!notification.message.includes(word)) {
        // check if notification to show or not and then getorgstatus 0
        customToast(
          notification.message,
          notification && notification.severity
            ? notification.severity
            : "critical"
        );
      }
      if (notification.vmId) {
        const messageHave = notification.message.split(" ");

        const requiredWords = ["Snapshot", "restored", "successfully"];
        const allWordsPresent = requiredWords.every((word) =>
          messageHave.includes(word)
        );
        if (allWordsPresent) {
          dispatch(setVmIdNotification(notification.vmId));
        }
      }

      dispatch(setLoading(true));
      dispatch(getOrgStatus(0));
    }
  });
  connection.start().then(() => {
    dispatch(getOrgStatus(0));
  });
};
